import { Store, createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';

import { AppState } from './root.types';
import rootReducer from './root.reducer';
import rootSaga from './root.sagas';
import { errorActionLoggingMiddleware, authErrorHandlerMiddleware } from './middleware';
import { logsHelper } from 'helpers';

export function configureStore(): Store<AppState> {
    const sagaMiddleware = createSagaMiddleware({
        onError: (error: Error) => {
            // unexpected (unhandled) errors in sagas, which break the whole application
            logsHelper.error(error);
        }
    });

    const store = createStore(
        rootReducer,
        {},
        composeWithDevTools(applyMiddleware(sagaMiddleware, errorActionLoggingMiddleware, authErrorHandlerMiddleware))
    );

    sagaMiddleware.run(rootSaga);

    return store;
}